<div
  *ngIf="notifications$ | async as notifs"
  [autoClose]="'outside'"
  class="dropdown topbar-head-dropdown ms-1 header-item"
  ngbDropdown
>
  <button
    class="btn btn-icon btn-topbar btn-ghost-primary rounded-circle"
    id="page-header-notifications-dropdown"
    ngbDropdownToggle
    type="button"
  >
    <i class="las la-bell fs-24"></i>
    <span
      *ngIf="notifs.length"
      class="position-absolute topbar-badge fs-9 translate-middle badge rounded-pill bg-danger"
    >{{ ns.totalNotifications }}</span
    >
  </button>

  <div class="dropdown-menu dropdown-menu-lg dropdown-menu-end p-0" ngbDropdownMenu>
    @if (notifs.length) {
      <div class="dropdown-head rounded-top">
        <div class="p-3 bg-primary bg-pattern">
          <div class="d-flex justify-content-between align-items-center">
            <h6 class="m-0 fs-16 fw-semibold text-white">{{ 'NOTIFICATION.NOTIFICATIONS' | translate }}</h6>
            <span
              *ngIf="notifs.length"
              class="badge bg-light-subtle text-light fs-13">
              {{ ns.totalNotifications }} {{ 'NOTIFICATION.NEW' | translate }}
            </span>
          </div>
        </div>

        <ngx-simplebar class="pe-2" style="max-height: 300px">
          <ng-container *ngFor="let n of notifs">
            <div class="text-reset notification-item d-block dropdown-item position-relative">
              <div class="d-flex">
                <div class="avatar-xs me-3">
                  <span
                    class="avatar-title bg-info-subtle text-info rounded-circle fs-16"
                  >
                    <i class="bx bx-badge-check"></i>
                  </span>
                </div>
                <div class="flex-1">
                  <h6
                    [innerHTML]="n.data.message"
                    class="mt-0 fs-14 mb-2 lh-base"
                  ></h6>
                  <p class="mb-0 fs-11 fw-medium text-uppercase text-muted">
                    <i class="mdi mdi-clock-outline"></i>
                    {{ n.createdAt | localizedDate: 'short' }}
                  </p>
                  <div class="d-flex mt-1 gap-2">
                    @if (n.data.buildingId) {
                      <a class="fs-11" [routerLink]="Resources.PropertiesProfile | resourceById:n.data.buildingId">
                        <u>{{ 'VIEW' | translate }}</u>
                      </a>
                    }
                    @if (n.data.contractId) {
                      <a class="fs-11" [routerLink]="Resources.PropertyContractsDetails | resourceById:n.data.contractId">
                        <u>{{ n.data.contractNumber }}</u>
                      </a>
                    }
                    @if (n.data.invoiceId) {
                      <a class="fs-11" [routerLink]="Resources.InvoiceDetails | resourceById:n.data.invoiceId">
                        <u>{{ n.data.invoiceNumber }}</u>
                      </a>
                    }
                    <button
                      (click)="mark(n.id);"
                      class="btn btn-link p-0 text-decoration-underline fs-11"
                    >
                      {{ 'NOTIFICATION.MARK_AS_READ' | translate }}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </ng-container>
          @if (showLoadMore) {
            <div class="d-flex justify-content-center">
              <button (click)="loadMore()" class="btn-sm my-2 btn btn-primary">
                {{ 'NOTIFICATION.LOAD_MORE' | translate }}
              </button>
            </div>
          }
        </ngx-simplebar>

        <div class="border-top text-center py-2">
          <a [routerLink]="[Resources.SettingsNotifications]" class="btn btn-soft-success btn-sm">
            {{ 'NOTIFICATION.SHOW_ALL' | translate }}
            <i class="ri-arrow-right-line align-middle"></i></a>
        </div>
      </div>
    } @else {
      <div class="fs-3 d-flex justify-content-center align-items-center" [style.height.px]="300">
        <i class="las la-bell"></i>
        {{ 'NOTIFICATION.NO_DATA' | translate }}
      </div>

      <a [routerLink]="[Resources.SettingsNotifications]" class="btn text-center w-100 btn-soft-success btn-sm">
        {{ 'NOTIFICATION.SHOW_ALL' | translate }}
        <i class="ri-arrow-right-line align-middle"></i>
      </a>
    }
  </div>
</div>
